import React from 'react';

/**
 * Contains the feature flags that are active for this user.
 */
export const FeatureFlags = React.createContext({});
